import styled from "styled-components";
import { 
  Form as AntForm,
  Typography as AntTypography 
} from "antd";
import { BackArrow } from '@assets';
import lightTheme from '@styles/theme';
import { AuthBg } from "@assets/auth";

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-image: url(${AuthBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  padding: 0px 16px;
`;

export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 16px;
`;

export const ArrowIconWrapper = styled.div`
  width: 50px;
  height: 50px;
  background-color: ${lightTheme.appbarColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
  cursor: pointer;
`

export const BackIcon = styled(BackArrow)`
  width: 15px;
  height: 11px;
`;

export const ContentContainer = styled.div`
  width: 100%;
  margin: 259px auto 24px;

  @media (max-height: 700px) {
    margin-top: 200px !important;
  }
`

export const Title = styled(AntTypography.Title)`
  color: #FFF !important;
  text-align: center;
  font-size: 24px !important;
  padding-left: 24px;
  font-style: normal;
  font-weight: 700 !important;
  line-height: normal !important;
` 

export const Form = styled(AntForm)`
  margin-top: 30px;
  width: 100%;
  text-align: center;

  .ant-form-item {
    margin-bottom: 32px;
  }

  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 24px;
  }

  .ant-form-item-label {
    margin-left: 24px;
    text-align: left;
    padding: 0 !important;
  }

  .ant-form-item-label label {
    color: #E1A59C;
    font-size: 14px;
    font-family: Plus Jakarta Sans;
    font-style: normal;
    font-weight: 400;
  }

  .ant-input-affix-wrapper {
    height: 52px;
    border: 1px solid #e1cce0;
    border-radius: 10px;

    input {
      text-align: center;
    }
  }

  .ant-btn-primary {
    margin-top: 30px;
    width: 100%;
    height: 52px;
    border-radius: 26px !important;
  }
`;

